var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("router-view", { attrs: { name: "header" } }),
      _vm.theChain
        ? _c("router-view", { key: _vm.key })
        : _c(
            "div",
            [
              _c(
                "el-result",
                {
                  attrs: {
                    icon: "warning",
                    title: "提示",
                    subTitle: "无权限访问",
                  },
                },
                [
                  _c(
                    "template",
                    { slot: "extra" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "medium" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/zxk/home")
                            },
                          },
                        },
                        [_vm._v("返回首页")]
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }